/**
 * ISO 3166-2 region-code derivation for DACH.
 *
 * Google's `administrative_area_level_1.short_name` is an abbreviation, NOT an ISO
 * 3166-2 code. For DE and CH the tail matches (`DE-BY`, `CH-ZH`), but AT uses numeric
 * codes (`AT-1`…`AT-9`) that must be looked up by the German region name. Geocoder
 * requests pin language to `de` so the long names are stable (see MapsGeocoder usage).
 * Anything underivable returns '' — never guessed.
 */

/** Austrian Bundesland (German long_name) → ISO 3166-2 tail. */
const AT_REGION_TO_ISO: Readonly<Record<string, string>> = {
  Burgenland: 'AT-1',
  Kärnten: 'AT-2',
  Niederösterreich: 'AT-3',
  Oberösterreich: 'AT-4',
  Salzburg: 'AT-5',
  Steiermark: 'AT-6',
  Tirol: 'AT-7',
  Vorarlberg: 'AT-8',
  Wien: 'AT-9',
};

export function deriveIso3166_2(
  countryCode: string,
  adminShortName: string,
  adminLongName: string,
): string {
  if (!countryCode) {
    return '';
  }
  switch (countryCode) {
    case 'DE':
    case 'CH':
      return adminShortName ? `${countryCode}-${adminShortName}` : '';
    case 'AT':
      return adminLongName in AT_REGION_TO_ISO
        ? AT_REGION_TO_ISO[adminLongName]
        : '';
    default:
      return '';
  }
}
